export default "__VITE_ASSET__BHvvtp2o__"